import cn from 'classnames';
import { FC, useEffect } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/common/Button';
import { envStrToBoolean, scrollToTop } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { CMSManager } from 'src/manager/CMSManager';
import { getInfoPages } from 'src/services/cmsApi';
import { openMyAccountModal } from 'src/store/account-modal/actions';
import { setBottomNavigation } from 'src/store/configs/actions';
import { toggleMobileBottomNavigation } from 'src/store/mobile/actions';
import { CmsInfoPagesResponse } from 'src/types/cms/cmsPageTypes';
import { RootState } from 'src/types/store-types';
import './styles.scss';

type Props = {
  settings: {
    type: string; //link
    viewType: string; // row | list
    priority: number;
    styles: Styles;
  };
};
const BottomNavigation: FC<Props> = ({ settings }) => {
  const { type, viewType } = settings;
  const navigate = useNavigate();
  const { locale } = useI18n();

  const { bottomNavigation } = useSelector((state: RootState) => state.configs);

  const _openAccountModal = useConnectedAction(openMyAccountModal);
  const _toggleMobileBottomNavigation = useConnectedAction(toggleMobileBottomNavigation);
  const _setBottomNavigation = useConnectedAction(setBottomNavigation);

  const handleNavItemClick = (name: string, slug: string): void => {
    const navigateToPage = envStrToBoolean(process.env.REACT_APP_BOTTOM_NAVIGATION_TO_PAGES);
    navigateToPage ? redirectToInfoAndRulesPage(slug) : openInfoAndRulesModal(name);
  };

  const openInfoAndRulesModal = (name: string): void => {
    _openAccountModal({ section: 'info_and_rules', subSection: name });

    isMobileOnly && _toggleMobileBottomNavigation();
  };

  const redirectToInfoAndRulesPage = (name: string): void => {
    const path = `/${name}`;
    path && navigate(path);
    path && scrollToTop();
  };

  const getStaticPageData = async (): Promise<void> => {
    const res: CmsInfoPagesResponse = await getInfoPages(locale);

    if (res?.result?.length) {
      const _ = CMSManager.inhouseCms.getInfoAndRulesData(res.result);

      _setBottomNavigation(_);
    } else {
      _setBottomNavigation([]);
      console.error('bottom navigation from csm is not found');
    }
  };

  useEffect(() => {
    if (locale) {
      getStaticPageData();
    }
  }, [locale]);

  return (
    <div
      className={cn('bottom_navigation_wrapper', {
        ['rules_row']: viewType === 'row',
        ['rules_list']: viewType === 'list',
      })}
    >
      {bottomNavigation?.map((navItem: any) => (
        <Button
          className={cn('rule', { ['link']: type === 'link' })}
          key={navItem.title}
          onClick={() => handleNavItemClick(navItem.name, navItem.slug)}
        >
          {navItem.title}
        </Button>
      ))}
    </div>
  );
};
export default BottomNavigation;
